// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"0832bfaf","708":"1f647728","787":"cda612ba"}[chunkId] + ".chunk.js";
};